export default __webpack_public_path__ + "static/media/plain-sticker-d.54051907.png";